import ExchangesModel from '../models/ExchangesModel';

export default class ExchangesCollection extends Backbone.Collection {
  constructor(options) {
    super(options);

    this.model = ExchangesModel;
  }

  url() {
    return (
      appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
      appConstants.ApiPaths.API_VERSION_PATH +
      appConstants.EndPoints.ADVERTISEMENTS_EXCHANGE_PATH
    );
  }

  parse(data) {
    return data.exchanges ? data.exchanges : data;
  }

  dispatchCallback(payload) {
    let actionType = payload.actionType;
    let ActionTypes = appConstants.ActionTypes;

    switch (actionType) {
      case ActionTypes.GET_EXCHANGES:
        Utils.setMakeshiftTokenHeader();
        ExchangesStore.fetch({
          url:
            appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
            appConstants.ApiPaths.API_VERSION_PATH +
            appConstants.EndPoints.ADVERTISEMENTS_EXCHANGE_PATH,
          type: 'GET',
          data: payload.postData,
          success: ExchangesStore.onExchangesHandler,
          fail: ExchangesStore.onExchangesError,
        });
        break;
      case ActionTypes.GET_ALL_EXCHANGES:
        Utils.setMakeshiftTokenHeader();
        ExchangesStore.fetch({
          reset: false,
          url:
            appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
            appConstants.ApiPaths.API_VERSION_PATH +
            appConstants.EndPoints.ADVERTISEMENTS_EXCHANGE_PATH,
          type: 'GET',
          data: payload.postData,
          success: ExchangesStore.onAllExchangesHandler,
          fail: ExchangesStore.onAllExchangesError,
        });
        break;
      case ActionTypes.CREATE_EXCHANGE:
        Utils.setMakeshiftTokenHeader();
        var shiftURL =
          appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
          appConstants.ApiPaths.API_VERSION_PATH +
          appConstants.EndPoints.ADVERTISEMENTS_POST_PATH.replace(
            '%d',
            payload.postData[Utils.getEndpointParam('SHIFT_IDS_PARAM')],
          );
        let newExchangeModel = new ExchangesModel(payload.postData);

        ExchangesStore.create(newExchangeModel, {
          patch: true,
          silent: true,
          wait: true,
          url: shiftURL,
          success: ExchangesStore.onAdvertisementsPostHandler,
          error: ExchangesStore.onAdvertismentsPostError,
        });

        break;

      case ActionTypes.CANCEL_EXCHANGE:
        Utils.setMakeshiftTokenHeader();
        let cancelRequest = payload.postData;
        let shiftID = cancelRequest[Utils.getEndpointParam('SHIFT_ID_PARAM')];
        let exchangeID = cancelRequest[Utils.getEndpointParam('EXCHANGE_ID_PARAM')];
        let cancelURL =
          appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
          appConstants.ApiPaths.API_VERSION_PATH +
          appConstants.EndPoints.ADVERTISEMENTS_EXCHANGE_PATH +
          '/' +
          exchangeID;
        let exchangeModel = ExchangesStore.get(exchangeID);

        if (exchangeModel) {
          exchangeModel.destroy({
            wait: true,
            url: cancelURL,
            success: ExchangesStore.onCancelExchangeSuccess,
            error: ExchangesStore.onCancelExchangeError,
          });
        } else {
          var deets = ExchangesStore.getExchangeShiftDetailsByShiftId(shiftID);
          if (_.isUndefined(deets)) {
            deets = ShiftStore.getAllShiftsByShiftId(shiftID);
          }
          ExchangesStore.fetch({
            url: cancelURL,
            data: { shiftID: shiftID, exchangeID: exchangeID, details: deets },
            type: 'DELETE',
            success: ExchangesStore.onCancelExchangeSuccess,
            error: ExchangesStore.onCancelExchangeError,
          });
        }
        ExchangesStore.removeExchangeShiftDetails(shiftID, exchangeID);
        ShiftStore.removeExchangesFromShift(shiftID, exchangeID);

        break;

      case ActionTypes.ACCEPT_EXCHANGE_BID:
        Utils.setMakeshiftTokenHeader();

        let bidRequest = payload.postData;
        let bid = bidRequest[Utils.getEndpointParam('BID_ID_PARAM')];
        var exchangeID = bidRequest[Utils.getEndpointParam('EXCHANGE_ID_PARAM')];
        var userID = bidRequest[Utils.getEndpointParam('USER_ID_PARAM')];
        var shiftID = bidRequest[Utils.getEndpointParam('SHIFT_ID_PARAM')];
        let acceptBidURL =
          appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
          appConstants.ApiPaths.API_VERSION_PATH +
          appConstants.EndPoints.BIDS_ACCEPT_PATH.replace('%d', exchangeID);
        var exchangeModel = ExchangesStore.getAdvertisementByExchangeID(exchangeID);
        if (!Utils.isNotDefined(shiftID)) {
          exchangeModel.accepted_shift_id = shiftID;
        }
        exchangeModel.accepted_user_id = userID;
        exchangeModel.drop = payload.postData['drop'];
        ExchangesStore.fetch({
          url: acceptBidURL,
          type: 'PUT',
          data: bidRequest,
          success: function(collection, response) {
            ExchangesStore.onBidAcceptedSuccess(collection, response, exchangeModel);
          },
          error: ExchangesStore.onBidAcceptedError,
        });
        break;

      default:
    }
  }
}
